import React from 'react';
import type { OpsTvStatus } from './types';

const TONE: Record<OpsTvStatus, string> = {
  LIVE: 'border-emerald-300/45 bg-[linear-gradient(135deg,rgba(16,185,129,0.3),rgba(2,24,21,0.86))] text-emerald-100 shadow-[0_0_24px_rgba(16,185,129,0.35)]',
  DELAYED: 'border-amber-300/45 bg-[linear-gradient(135deg,rgba(245,158,11,0.24),rgba(39,20,4,0.86))] text-amber-100 shadow-[0_0_24px_rgba(245,158,11,0.32)]',
  'LAST SEEN': 'border-amber-300/45 bg-[linear-gradient(135deg,rgba(245,158,11,0.22),rgba(33,22,7,0.88))] text-amber-100 shadow-[0_0_20px_rgba(245,158,11,0.28)]',
  OFFLINE: 'border-rose-300/50 bg-[linear-gradient(135deg,rgba(244,63,94,0.24),rgba(45,9,20,0.9))] text-rose-100 shadow-[0_0_24px_rgba(244,63,94,0.36)]',
  'IN FLIGHT': 'border-emerald-300/45 bg-[linear-gradient(135deg,rgba(16,185,129,0.28),rgba(2,24,21,0.86))] text-emerald-100 shadow-[0_0_24px_rgba(16,185,129,0.35)]',
  'TAXI OUT': 'border-amber-300/45 bg-[linear-gradient(135deg,rgba(245,158,11,0.26),rgba(39,20,4,0.86))] text-amber-100 shadow-[0_0_24px_rgba(245,158,11,0.35)]',
  'TAXI IN': 'border-orange-300/45 bg-[linear-gradient(135deg,rgba(249,115,22,0.26),rgba(45,17,5,0.86))] text-orange-100 shadow-[0_0_24px_rgba(249,115,22,0.35)]',
  'ON GROUND': 'border-sky-300/45 bg-[linear-gradient(135deg,rgba(14,165,233,0.2),rgba(7,22,39,0.86))] text-sky-100 shadow-[0_0_24px_rgba(14,165,233,0.3)]',
  ARRIVED: 'border-cyan-300/45 bg-[linear-gradient(135deg,rgba(6,182,212,0.24),rgba(3,21,25,0.86))] text-cyan-100 shadow-[0_0_24px_rgba(6,182,212,0.3)]',
  'NO ACTIVE TRIP': 'border-slate-300/45 bg-[linear-gradient(135deg,rgba(100,116,139,0.26),rgba(15,23,42,0.86))] text-slate-100',
  UNKNOWN: 'border-slate-300/45 bg-[linear-gradient(135deg,rgba(100,116,139,0.26),rgba(15,23,42,0.86))] text-slate-100',
};

const DOT: Record<OpsTvStatus, string> = {
  LIVE: 'bg-emerald-300',
  DELAYED: 'bg-amber-300',
  'LAST SEEN': 'bg-amber-300',
  OFFLINE: 'bg-rose-300',
  'IN FLIGHT': 'bg-emerald-300',
  'TAXI OUT': 'bg-amber-300',
  'TAXI IN': 'bg-orange-300',
  'ON GROUND': 'bg-sky-300',
  ARRIVED: 'bg-cyan-300',
  'NO ACTIVE TRIP': 'bg-slate-300',
  UNKNOWN: 'bg-slate-300',
};

const OperationsTvStatusPill: React.FC<{ status: OpsTvStatus }> = ({ status }) => (
  <span
    className={`inline-flex items-center justify-center gap-2 rounded-full border px-3 py-1 text-[11px] font-black uppercase tracking-[0.12em] ${TONE[status]}`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${DOT[status]} shadow-[0_0_10px_currentColor] ${status === 'LIVE' || status === 'IN FLIGHT' ? 'ops-tv-status-dot-live' : ''}`} />
    {status}
  </span>
);

export default OperationsTvStatusPill;
